import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@hooks/useTheme";
import { DropIcon } from "../Icons";
import PrimaryButton from "../Buttons/PrimaryButton";
import VerificationResultSelectionModal from "../UI/VerificationResultSelectionModal";

const VerificationComparisonSelector = ({
  onSelect,
  selectedVerificationResult,
  excludedVerificationResult = null,
  verificationNumber,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const [showModal, setShowModal] = useState(false);

  const onClickSelectVerificationResult = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <div className="w-full h-[224px]" data-testid="verification-comparison-selector">
      <div className="flex flex-col items-center text-center h-full justify-between pt-6">
        {/* Icon */}
        <div className="mb-4">
          <DropIcon className={`w-12 h-12 lg:w-16 lg:h-16 ${colors.textActive}`}/>     
        </div>

        {/* Instruction Text */}
        <p className={`text-sm ${colors.textSecondary} mb-4 flex-1`}>
          {t("verification-comparison.select-instruction")}
        </p>

        {/* Button */}
        <PrimaryButton
          size="md"
          data-testid="verification-comparison-selector-select-button"
          onClick={onClickSelectVerificationResult}
          className="mb-24"
        >
          {selectedVerificationResult
            ? selectedVerificationResult.projectPreviewName || selectedVerificationResult.projectName || t("verification-comparison.verification-result-1")
            : verificationNumber === 1 ? t("verification-comparison.select-verification-result-1") : t("verification-comparison.select-verification-result-2")
          }
        </PrimaryButton>
      </div>

      {/* Verification Result Selection Modal */}
      <VerificationResultSelectionModal
        isOpen={showModal}
        onClose={handleModalClose}
        onSelect={onSelect}
        selectedVerificationResult={selectedVerificationResult}
        excludedVerificationResult={excludedVerificationResult}
      />
    </div>
  );
};

export default VerificationComparisonSelector; 